import { Alert } from '@creditornot/cb-alert';
import { typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { ValidationError } from '../errors';

const ListItems = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 4px 20px;
`;

const ListItem = styled.li`
  ${typographyCss.Body3()}
  list-style: disc;
`;

type ErrorsAlertProps = {
  message: string;
  validationErrors?: ValidationError[];
};

export const SubmissionErrors = ({ message, validationErrors }: ErrorsAlertProps) => {
  return (
    <Alert variant="error">
      <b>{message}</b>

      {!!validationErrors?.length && (
        <ListItems>
          {validationErrors.map((error: ValidationError) => (
            <ListItem key={error.value}>
              <span>{error.reason}</span> - <span>{error.value}</span>
            </ListItem>
          ))}
        </ListItems>
      )}
    </Alert>
  );
};
